import { puedeVerRuta, rutaDeCliente, RUTAS_ESTATICAS, type Rol } from "@/routes/routeConfig";

/** Lo único que sobrevive a un cambio de cliente: pertenece al usuario, no al cliente anterior. */
const PARAMETROS_GENERICOS: ReadonlySet<string> = new Set(["periodo", "estado", "vista", "dia"]);

const CLIENTE_EN_RUTA = /^\/c\/[^/]+\/?(.*)$/;

interface Entrada {
  pathname: string;
  search: string;
  nuevoSlug: string;
  rol: Rol;
}

/** Sección de la ruta actual sin los parámetros de ruta (`landings/:slug` → `landings`). */
function seccionEstatica(resto: string): string | null {
  const limpia = resto.replace(/\/+$/, "");
  const candidatas = RUTAS_ESTATICAS.filter((ruta) => limpia === ruta || limpia.startsWith(`${ruta}/`));
  return candidatas.sort((a, b) => b.length - a.length)[0] ?? null;
}

/** URL de la misma sección en otro cliente (se navega con `push` para que «Atrás» vuelva al anterior). */
export function urlParaCambioDeCliente({ pathname, search, nuevoSlug, rol }: Entrada): { pathname: string; search: string } {
  const resto = CLIENTE_EN_RUTA.exec(pathname)?.[1] ?? "";
  const seccion = seccionEstatica(resto);
  const destino = seccion && puedeVerRuta(rol, seccion) ? seccion : "inicio";
  const origen = new URLSearchParams(search);
  const conservados = new URLSearchParams();
  if (destino !== "inicio") {
    for (const [nombre, valor] of origen) {
      if (PARAMETROS_GENERICOS.has(nombre)) conservados.set(nombre, valor);
    }
  }
  const query = conservados.toString();
  return { pathname: rutaDeCliente(nuevoSlug, destino), search: query ? `?${query}` : "" };
}
